import { Link } from 'react-router-dom';

export default function EmptyAccessState({
  title = 'Nessun accesso disponibile',
  description = 'La configurazione corrente del tenant non espone contenuti disponibili.',
  actionLabel = '',
  actionTo = '',
}) {
  return (
    <div className="p-8">
      <div className="rounded-3xl border border-[var(--border)] bg-[var(--surface-raised)] p-10 shadow-sm">
        <h1 className="text-3xl font-bold text-[var(--text-primary)]">{title}</h1>
        <p className="mt-3 max-w-2xl text-base text-[var(--text-secondary)]">{description}</p>
        {actionLabel && actionTo ? (
          <div className="mt-6">
            <Link
              to={actionTo}
              className="inline-flex items-center rounded-xl bg-[var(--success)] px-4 py-2 text-sm font-medium text-[var(--on-primary)] transition-colors hover:bg-[var(--success)]"
            >
              {actionLabel}
            </Link>
          </div>
        ) : null}
      </div>
    </div>
  );
}
